import { createFileRoute } from '@tanstack/react-router';
import { dashboardQueryOptions } from '@/features/dashboard/api';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { marketsQueryOptions, readStoredMarket, resolveMarketId } from '@/lib/market';

export const Route = createFileRoute('/_auth/')({
  // Préchargement ; les erreurs sont rendues par la page (`ErrorState`).
  loader: async ({ context }) => {
    const markets = await context.queryClient
      .ensureQueryData(marketsQueryOptions())
      .catch(() => undefined);
    const marketId = resolveMarketId({
      fromSearch: undefined,
      stored: readStoredMarket(),
      markets,
    });
    if (!marketId) return;
    await context.queryClient
      .ensureQueryData(dashboardQueryOptions(marketId))
      .catch(() => undefined);
  },
  component: DashboardPage,
});
